/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProductValueTransferSnapshotRequest} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'
import {ProductValueTransferSnapshotResponse} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'


export const getProductValueTransferSnapshot = (request: ProductValueTransferSnapshotRequest, options?: CashRequestOptions) => post<ProductValueTransferSnapshotRequest, ProductValueTransferSnapshotResponse>("/2.0/cash/get-product-value-transfer-snapshot", request, {...options, rejectOnError: true })